import { render } from "./SwitchComponent.vue?vue&type=template&id=00de69ea"
import script from "./SwitchComponent.vue?vue&type=script&lang=js"
export * from "./SwitchComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__